import { useContext } from 'react';

// auth provider

import { NotificationsContext } from 'contexts/NotificationsContext';

// ==============================|| AUTH HOOKS ||============================== //

const useNotifications = () => {
    const context = useContext(NotificationsContext);

    if (!context) throw new Error('context must be use inside provider');

    return context;
};

export default useNotifications;
